import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const ContainerFooter = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  z-index: ${BaSeTheme.stackOrder.normal};
`;

export const FooterWrapper = styled.div`
  text-align: center;
  width: 100vw;
  footer {
  }
`;
